const initialState = {
  auth: "",
};
const AuthReducer = (state = initialState, action) => {
  switch (action.type) {
    case "login":
      return action.payload;
    default:
      return state;
  }
};
export default AuthReducer;
